export default {
  nav: {
    portfolio: "Widyo의 포트폴리오",
    whyme: "왜 저를 선택해야 하나요?",
    education: "교육",
    experience: "경험",
    organizational: "조직",
    events: "이벤트",
    portfolio_link: "포트폴리오",
    skills: "기술",
    certificates: "자격증",
    awards: "수상 및 인증",
    contact: "연락처",
    downloadResume: "이력서 다운로드",
    downloadPortfolio: "포트폴리오 다운로드",
    letsConnect: "연결하기",
  },
  hero: {
    greeting: "안녕하세요!",
    name: "저는 Widyo Tri Cahya Utomo입니다",
    nickname: "Dio",
    title: "DevOps 엔지니어 | 데이터 엔지니어",
    description: "Apple Developer Institute의 DevOps 엔지니어로, Terraform과 Ansible로 AWS 인프라를 코드로 자동화하고 CI/CD 파이프라인을 구축합니다. ETL/CDC, 클라우드 마이그레이션, 데이터 플랫폼을 포함한 3년간의 엔터프라이즈 데이터 엔지니어링 경험이 바탕입니다.",
    downloadResume: "이력서 다운로드",
    contactMe: "연락하기",
  },
  whyme: {
    title: "왜 저를 선택해야 하나요?",
    subtitle: "DevOps 엔지니어로서 저의 차별점",
    content: "저는 단순히 데이터를 이동시키는 것이 아니라, 실질적인 비즈니스 가치를 창출하는 인텔리전스로 전환합니다. 호기심 어린 회의주의로 모든 문제에 접근하며, 가정을 검증하고 확장 가능하고 안정적이며 실제로 성과를 제공하는 시스템을 설계합니다. 저의 경험은 수집, 웨어하우징, 오케스트레이션, 거버넌스, 성능 튜닝을 포함한 엔드투엔드 데이터 엔지니어링에 걸쳐 있습니다. 실패가 용납되지 않는 엔터프라이즈 환경에서 일해왔기 때문에 안정성, 보안, 정밀성은 타협할 수 없습니다. 깨끗한 아키텍처, 효율적인 파이프라인, 문제를 일으키는 것이 아니라 예방하는 자동화에 집착합니다. 40개 이상의 산업 인증과 AI 및 Web3에 대한 미래 지향적인 초점으로 오늘의 요구와 내일의 혁신을 위해 설계된 시스템을 구축합니다. 간단히 말해, 저는 임팩트를 위해, 규모를 위해, 미래를 위해 구축된 데이터 솔루션을 제공합니다.",
  },
  tools: {
    title: "매일 사용하는 도구 및 기술 중 일부",
  },
  education: {
    title: "교육",
    subtitle: "데이터 시스템에 중점을 둔 컴퓨터 공학의 학문적 기반",
    graduated: "졸업",
    institutions: {
      maranatha: {
        name: "마라나타 기독교 대학교",
        degree: "공학사(B.E.), 컴퓨터 공학",
        highlights: [
          "GPA: 3.83",
          "관련 과목: 데이터베이스, 운영 체제, 컴퓨터 네트워크",
        ],
      },
      yosuka: {
        name: "요스 수다르소 고등학교 - 카라왕",
        degree: "수학 및 과학 전공",
        status: "고등학교 졸업장",
      },
      akademicrypto: {
        name: "아카데미 크립토 - 탕에랑",
        degree: "Web3 및 블록체인 비학위 프로그램",
        status: "2024년 3월 - 현재",
        highlights: [
          "Web3, 블록체인 기초 및 분산 기술에 중점",
          "암호 경제학, 스마트 계약 및 DeFi 생태계에 대한 적극적인 학습",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - 자카르타",
        degree: "금융 거래 및 시장 분석 비학위 프로그램",
        status: "2025년 9월 - 현재",
        highlights: [
          "기본 분석과 기술 분석을 모두 사용한 암호화폐 거래에 중점",
          "커뮤니티 학습을 통해 실용적인 거래 전략 및 시장 평가 기술 개발",
        ],
      },
    },
  },
  experience: {
    title: "경험",
    subtitle: "클라우드 인프라 자동화, 그리고 다양한 산업 분야의 엔터프라이즈 데이터 엔지니어링 및 기술 컨설팅",
  },
  organizational: {
    title: "조직 및 커뮤니티",
    subtitle: "전문 조직 및 커뮤니티에서의 리더십 역할 및 적극적인 참여",
    activities: [
      {
        title: "대학 리더십",
        organization: "마라나타 기독교 대학교",
        role: "디지털 컴퓨터 랩 책임자",
        dates: "2021년 4월 - 2023년 4월",
        description: "실험실을 주도하고 프로젝트 및 학생 멘토링을 관리.",
      },
      {
        title: "암호화 커뮤니티",
        organization: "아카데미 크립토, TradeWithSuli, Coin Kami",
        role: "활동 회원",
        dates: "2023년 2월 - 현재",
        description: "Web3 및 암호화 커뮤니티의 적극적인 참여자이자 평생 학습자.",
      },
      {
        title: "커넥트 그룹 및 멀티미디어 사역",
        organization: "로즈 오브 샤론 교회",
        role: "활동 회원",
        dates: "2015년 8월 - 현재",
        description: "커넥트 그룹 교제와 멀티미디어 사역에서 봉사하며 교회 커뮤니티에 적극적으로 참여하여 예배 및 창의적인 미디어 제작 지원.",
      },
    ],
  },
  events: {
    title: "이벤트 & 갤러리",
    subtitle: "이벤트, 컨퍼런스, 세미나 및 전문 활동의 사진 및 하이라이트",
    noImages: "이미지가 없습니다",
    maintenance: "유지보수 중",
    maintenanceDesc: "이 섹션은 현재 새로운 콘텐츠로 업데이트 중입니다. 곧 다시 확인해주세요!",
  },
  portfolio: {
    title: "포트폴리오",
    subtitle: "웹 개발 및 데이터 엔지니어링 작업을 보여주는 선별된 프로젝트",
    webPortfolioTitle: "웹 포트폴리오",
    dataPortfolioTitle: "데이터 엔지니어링 포트폴리오",
    viewLive: "라이브 보기",
    explore: "탐색",
    showMore: "더 보기",
    showLess: "덜 보기",
    downloadPdf: "포트폴리오를 PDF로 다운로드",
    generatingPdf: "PDF 생성 중...",
    selectProjects: "프로젝트 선택",
    selectAll: "모두 선택",
    cancel: "취소",
    downloadSelected: "다운로드",
    webProjects: [
      {
        title: "Maju Cipta Karya 웹사이트",
        description: "Maju Mapan은 우아한 디자인과 지속 가능성을 결합한 현대적인 가구 브랜드입니다. 각 작품은 친환경 재료를 사용하여 지역 장인이 수작업으로 제작하여 모든 생활 공간에 편안함, 균형 및 따뜻함을 선사합니다.",
      },
      {
        title: "Tcuber Store 웹사이트",
        description: "Tcuber Store는 인도네시아의 신뢰할 수 있는 온라인 게임 충전 플랫폼으로 Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans, PUBG Mobile과 같은 인기 게임에 빠르고 안전하며 저렴한 디지털 크레딧을 제공합니다. 다양한 결제 방법과 신속한 지원을 제공하여 원활한 게임 경험을 보장합니다.",
      },
    ],
    dataProjects: [
      {
        title: "AI를 활용한 펭귄 데이터 분석",
        description: "AI 기반 대화형 데이터 탐색 도구. 자연어 질문으로 펭귄 종 데이터를 분석하고 동적 차트를 통해 인사이트를 시각화합니다. React, Recharts 및 Lovable AI로 구축되었습니다.",
      },
    ],
    penguinExplorer: {
      title: "펭귄에 대해 질문하기",
      selectQuestion: "무엇을 알고 싶으신가요?",
      submit: "제출",
      analyzing: "분석 중...",
      thinking: "생각 중...",
      errorLoading: "펭귄 데이터 로드 오류",
      errorAnalyzing: "데이터 분석 오류",
      rateLimitError: "속도 제한을 초과했습니다. 나중에 다시 시도하세요.",
      paymentError: "결제가 필요합니다. Lovable AI 작업 공간에 크레딧을 추가하세요.",
      speciesDistribution: "종 분포",
      billVsBody: "부리 길이 대 체중",
      dataTable: "데이터 미리보기",
      questions: [
        "가장 긴 부리를 가진 펭귄은 무엇인가요?",
        "가장 무거운 펭귄은 어디에 살고 있나요?",
        "가장 짧은 지느러미를 가진 펭귄은 무엇인가요?",
      ],
    },
  },
  skills: {
    title: "기술",
    subtitle: "엔터프라이즈 데이터 엔지니어링을 기반으로 한 클라우드 인프라, 자동화, CI/CD",
    categories: {
      cloud: "클라우드 및 인프라",
      iac: "IaC 및 GitOps",
      cicd: "CI/CD",
      containers: "컨테이너 및 관측성",
      security: "보안 및 네트워킹",
      databases: "데이터베이스",
      etl: "ETL 및 통합",
      programming: "프로그래밍",
      soft: "소프트 스킬",
    },
  },
  certificates: {
    title: "Dataiku 자격증",
    subtitle: "Dataiku의 데이터 과학, 머신 러닝 및 AI 전문 인증",
    clickToView: "클릭하여 전체 자격증 보기",
    download: "다운로드",
    verify: "확인",
    preview: "자격증 미리보기",
  },
  awards: {
    title: "수상 및 인증",
    subtitle: "데이터 플랫폼, 클라우드 인프라 및 AI 기술에 대한 전문 인증",
    view: "보기",
  },
  contact: {
    title: "연락하기",
    subtitle: "기회, 협업 및 강연 요청을 환영합니다",
    info: "연락처 정보",
    email: "이메일",
    phone: "전화",
    social: "소셜 미디어",
    sendMessage: "메시지 보내기",
    name: "이름",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "메시지",
    messagePlaceholder: "Masukkan pesan",
    send: "메시지 보내기",
    copyright: "© 2025 Widyo Tri Cahya Utomo. 모든 권리 보유.",
  },
  whatsapp: {
    title: "연락하기",
    subtitle: "연락 방법을 선택하세요",
    chatbot: "AI 어시스턴트와 채팅",
    whatsapp: "WhatsApp으로 메시지",
    defaultMessage: "안녕하세요 Widyo! 연락하고 싶습니다.",
  },
  chatbot: {
    title: "AI 어시스턴트",
    welcome: "안녕하세요! 저는 Widyo의 AI 어시스턴트입니다. 그의 경험, 기술 및 프로젝트에 대한 질문에 답변해 드릴 수 있습니다. 어떻게 도와드릴까요?",
    placeholder: "메시지를 입력하세요...",
    error: "죄송합니다. 오류가 발생했습니다. 다시 시도해 주세요.",
  },
};
